import { CardFilterView } from "@/components/v2/CardView/components/CardFilterView";
import { useTrans } from "@/translations";

import { useContext, useMemo } from "react";

import { Granularity } from "server/dwhApi/common.js";

import { ReportingTableContext } from "../../context";

export const ReportingGranularityFilter = () => {
  const { t } = useTrans();
  const { granularity, setGranularity } = useContext(ReportingTableContext);

  const granularityOptions = useMemo(
    () =>
      Object.values(Granularity).map((key) => ({
        key,
        label: t(`homePage:${key}Granularity`),
      })),
    [t],
  );

  const granularityFilter = useMemo(
    () => ({
      options: granularityOptions,
      value: granularity,
      onChange: (key: string) => setGranularity(key as Granularity),
      largeView: true,
    }),
    [granularity, setGranularity, granularityOptions],
  );

  return (
    <>
      <span className="text-grey6 text-[12px] font-semibold">
        {t("reportingPage:tableGroupBy")}
      </span>
      <CardFilterView filter={granularityFilter} />
    </>
  );
};
